import { managerHost } from './index';

export async function createSession(sessionId: string) {
  const response = await managerHost.post('/sessions', { sessionId });
  const { connection } = response.data;

  return connection;
}
